// @flow
import React, { Fragment } from 'react';
import Fieldset from '@clark-inc/clark-forms';

import PlaidLink from 'components/plaid-link';
import Layout from 'components/shared/layout';
import { RECEIPT_FIELD, AUTOPAY_FIELD } from 'constants/payer/charge';

import { BankSetupLinks, BoldText, SubmitInfoCopy } from './styles';

const ConfirmOrChangeBankCopy = ({ bankName, bankAccountLast4, bankAccountType } = {}) => {
  if (!bankName) {
    return 'Add your bank account to pay your first invoice and setup convenient, one-click payments for future invoices.';
  }

  return (
    <span>
      {`Pay using your `}
      <BoldText>{bankName}</BoldText>
      {` ${bankAccountType} account ending in `}
      <BoldText>{bankAccountLast4}</BoldText>
      {` `}
      or contact your business administrator to add another payment method.
    </span>
  );
};

const BankAccountDetailsForm = ({
  pendingBankAccountAttributes,
  paymentMethod: existingPaymentMethod = {},
  business: {
    attributes: { name: businessName },
  },
  handlePlaidSuccess,
}: any) => {
  const { attributes } = existingPaymentMethod;
  const bankAttributes = pendingBankAccountAttributes || attributes;

  return (
    <Layout>
      <Fragment>
        <SubmitInfoCopy>{ConfirmOrChangeBankCopy(bankAttributes)}</SubmitInfoCopy>

        <BankSetupLinks>
          {!bankAttributes && (
            <PlaidLink clientName={businessName} onSuccess={handlePlaidSuccess}>
              {' '}
              Connect Your Bank
            </PlaidLink>
          )}
        </BankSetupLinks>

        {pendingBankAccountAttributes && (
          <>
            <Fieldset data={RECEIPT_FIELD} />
            <Fieldset data={AUTOPAY_FIELD} />
          </>
        )}
      </Fragment>
    </Layout>
  );
};

export default BankAccountDetailsForm;



// WEBPACK FOOTER //
// ./src/components/payer/bank-account-details-form/index.js